import { render } from "./DeviceGroup.vue?vue&type=template&id=4da39a18&scoped=true"
import script from "./DeviceGroup.vue?vue&type=script&lang=js"
export * from "./DeviceGroup.vue?vue&type=script&lang=js"

import "./DeviceGroup.vue?vue&type=style&index=0&id=4da39a18&scoped=true&lang=css"

import exportComponent from "C:\\All Projects\\Digital Sinage Main\\Digital Sinage Admin\\media-device-frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4da39a18"]])

export default __exports__